// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fwwx","colBig":"styles_colBig__3p3BL","colSmall":"styles_colSmall__3ml3e","shopifyNameWrapper":"styles_shopifyNameWrapper__c-NMO"};